import { isNullOrEmpty } from "../utils/string";
import { AppModule as CoreAppModule } from "./../core/AppModule";
export class AppModule extends CoreAppModule {
    get moduleId() {
        return (AppModule.MODULE_KEY);
    }
    get articleManager() {
        return (this.mArticleManager);
    }
    constructor(pArticleManager) {
        super();
        this.mArticleManager = pArticleManager;
    }
    clearDocumentData() {
        this.mArticleManager._clear();
    }
    async loadDocumentData(pContext, pData) {
        //get obk from document
        const tBuffer = await pContext.getResource("project.obk", true);
        const tSession = this.mArticleManager.session;
        if (tSession.isValid) {
            //upload to eaiws and load session
            const tBlob = new Blob([tBuffer]);
            const tUrl = await tSession.uploadFile("Project", tBlob);
            if (isNullOrEmpty(tUrl))
                throw new Error("Failed to upload obk.");
            await tSession.session.loadSession(tUrl);
            await tSession.deleteFile(tUrl);
        }
    }
    async saveDocumentData(pContext, pOptions) {
        if (pContext == null)
            return (null);
        if (pOptions.embedAppModuleResources) {
            //download obk and add it to the document, this will also synchronize the session
            const tUrl = await this.mArticleManager.saveToObk(false);
            if (isNullOrEmpty(tUrl))
                throw new Error("Failed to get obk url.");
            await pContext.addResourceFromUrl(tUrl, "project.obk", true, false);
        }
        return (null); //no additional data
    }
}
AppModule.MODULE_KEY = "egr.wcf.cf";
